"use strict";

exports.__esModule = true;
exports.CARD_SIZE_LARGE = exports.CARD_SIZE_MEDIUM = exports.CARD_SIZE_SMALL = void 0;
var CARD_SIZE_SMALL = 0;
exports.CARD_SIZE_SMALL = CARD_SIZE_SMALL;
var CARD_SIZE_MEDIUM = 1;
exports.CARD_SIZE_MEDIUM = CARD_SIZE_MEDIUM;
var CARD_SIZE_LARGE = 2;
exports.CARD_SIZE_LARGE = CARD_SIZE_LARGE;